import actionTypes from "../../common/actionTypes";
import { DATABASE_STATUTES } from "../../common/constants";

const notificationReducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_NOTIFICATIONS:
      return {
        ...state,
        status: DATABASE_STATUTES.LOADING,
        error: null,
      };

    case actionTypes.FETCH_NOTIFICATIONS_SUCCESS:
      return {
        ...state,
        notifications: action.payload.notifications,
        status: DATABASE_STATUTES.LOADED,
        error: null,
      };

    case actionTypes.FETCH_NOTIFICATIONS_FAILURE:
      return {
        ...state,
        status: DATABASE_STATUTES.ERROR,
        error: action.error,
      };

    case actionTypes.FETCH_NOTIFICATION:
      return {
        ...state,
        status: DATABASE_STATUTES.LOADING,
        error: null,
      };

    case actionTypes.FETCH_NOTIFICATION_SUCCESS:
      return {
        ...state,
        currentNotification: action.payload.notification,
        status: DATABASE_STATUTES.LOADED,
        error: null,
      };

    case actionTypes.FETCH_NOTIFICATION_FAILURE:
      return {
        ...state,
        status: DATABASE_STATUTES.ERROR,
        error: action.error,
      };

    case actionTypes.UPDATE_NOTIFICATION:
      return {
        ...state,
        status: DATABASE_STATUTES.LOADING,
        error: null,
      };

    case actionTypes.UPDATE_NOTIFICATION_SUCCESS:
      return {
        ...state,
        notifications: state.notifications.map((notification) =>
          Number(notification.id) === Number(action.payload.notification.id)
            ? action.payload.notification
            : notification
        ),
        currentNotification: action.payload.notification,
        status: DATABASE_STATUTES.LOADED,
        error: null,
      };

    case actionTypes.UPDATE_NOTIFICATION_FAILURE:
      return {
        ...state,
        status: DATABASE_STATUTES.ERROR,
        error: action.error,
      };

    default:
      return state;
  }
};

export default notificationReducer;
